const initMobileNav = () => {
    const mobilePanelTriggers = document.querySelectorAll('.mobilenav__leveltwo__link');
    mobilePanelTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            //debugger
            const panelToToggleName = e.target.getAttribute('aria-controls');
			const panelToToggleElem = document.querySelector(`#${panelToToggleName}`);

            if (panelToToggleElem) {
                toggleMobilePanel(panelToToggleElem);
            } else {
                throw new Error(`No panel found with id ${panelToToggleName}`);
            }
        });
    });

    // Back button 
    document.querySelectorAll('.mobilenav__tabcontent__paneBack').forEach(backButton => {
        backButton.addEventListener('click', (e) => {
            closeAllMobilePanels();
        });
	});


	// Toggle main mobile nav container
	const mobileNavToggleButton = document.querySelector('.nav-toggle__btn');
	mobileNavToggleButton?.addEventListener('click', (e) => {
		document.querySelector('html').classList.toggle('mobilenav-open');
		mobileNavToggleButton.classList.toggle('open');

		if (mobileNavToggleButton.classList.contains('open')) {
			mobileNavToggleButton.innerText = 'Close';
		} else {
			mobileNavToggleButton.innerText = 'Menu';
		}
	});
	
}

const toggleMobilePanel = (elem) => {
    // Close all other panels
    closeAllMobilePanels();

	elem.setAttribute('aria-hidden', false);

	document.querySelector('.mobilenav__secondarynav-outercontainer').classList.add('d-none');
}

const closeAllMobilePanels = () => {
    document.querySelectorAll('.mobilenav__tabcontent__pane').forEach(panel => {
		panel.setAttribute('aria-hidden', true);
		document.querySelector('.mobilenav__secondarynav-outercontainer').classList.remove('d-none');
    });
}

export {
    initMobileNav,
}
